export default __webpack_public_path__ + "static/10.03-cf7ff159c0bf27e492b1cac9e606d7d3.png";